import React from 'react';

import { clsx } from 'clsx';

import FadeIn from 'src/components/elements/FadeIn';
import Card from 'src/components/pages/PartnersPage/components/Card';
import { ResultCards } from 'src/components/pages/PartnersPage/constants';

import styles from './../../PartnersPage.scss';

const Results = () => (
  <section data-locator="partnersResults" className={styles.blockContainer}>
    <FadeIn delay={0.2} className={styles.title}>
      <span className={clsx(styles.title, styles.titleThin)}>Drive for</span> results
    </FadeIn>
    <FadeIn delay={0.4}>
      <p className={styles.subTitle}>
        Our travel loyalty solution is designed to grow your revenues
      </p>
    </FadeIn>
    <FadeIn delay={0.6} className={styles.cardsContainer}>
      {ResultCards.map((card, i) => (
        <Card item={card} cardStyle={styles.cardContainer} key={i} />
      ))}
    </FadeIn>
  </section>
);

export default Results;
